import { Instance } from '@tableau/telemetry-api-contract';
import { DashboardButtonBehaviour, DashboardButtonType } from '../../gen-src/preslayer/Enums';
import { ButtonZoneTelemetryInterface } from './ButtonZoneTelemetryInterface';

export class ButtonZoneVizClientTelemetry implements ButtonZoneTelemetryInterface {
  public static readonly AuthoringMode = 'Authoring';
  public static readonly ViewMode = 'View';
  public static readonly ButtonActionTelemetry = 'DashboardAuthoring_ButtonAction';
  public static readonly OpenButtonConfigDialogTelemetry = 'DashboardAuthoring_OpenButtonConfigDialog';
  public static readonly OpenButtonPermissionsErrorDialogTelemetry = 'DashboardAuthoring_OpenButtonPermissionsErrorDialog';

  public static readonly AuthoringModeKey = 'AuthoringMode';
  public static readonly ClickTypeKey = 'ClickType';
  public static readonly ButtonTypeKey = 'ButtonType';
  public static readonly ButtonBehaviorKey = 'ButtonBehavior';

  public logButtonActionInvoked(
    isAuthoring: boolean,
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    Instance.reportEvent(ButtonZoneVizClientTelemetry.ButtonActionTelemetry, [
      ButtonZoneVizClientTelemetry.AuthoringModeKey,
      isAuthoring ? ButtonZoneVizClientTelemetry.AuthoringMode : ButtonZoneVizClientTelemetry.ViewMode,
      ButtonZoneVizClientTelemetry.ClickTypeKey,
      clickType,
      ButtonZoneVizClientTelemetry.ButtonTypeKey,
      buttonType,
      ButtonZoneVizClientTelemetry.ButtonBehaviorKey,
      buttonBehavior,
    ]);
  }

  public logOpenButtonConfigDialogInvoked(
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    Instance.reportEvent(ButtonZoneVizClientTelemetry.OpenButtonConfigDialogTelemetry, [
      ButtonZoneVizClientTelemetry.ClickTypeKey,
      clickType,
      ButtonZoneVizClientTelemetry.ButtonTypeKey,
      buttonType,
      ButtonZoneVizClientTelemetry.ButtonBehaviorKey,
      buttonBehavior,
    ]);
  }

  public logOpenButtonPermissionsErrorDialogInvoked(
    clickType: string,
    buttonType: DashboardButtonType,
    buttonBehavior: DashboardButtonBehaviour
  ): void {
    Instance.reportEvent(ButtonZoneVizClientTelemetry.OpenButtonPermissionsErrorDialogTelemetry, [
      ButtonZoneVizClientTelemetry.ClickTypeKey,
      clickType,
      ButtonZoneVizClientTelemetry.ButtonTypeKey,
      buttonType,
      ButtonZoneVizClientTelemetry.ButtonBehaviorKey,
      buttonBehavior,
    ]);
  }
}
